/* add class selectors or id, parents, of the slider you want to ignore.
note that it must be the parent closest to your slider.
These sliders will be ignored when loading general
sliders, or those you want to add via a click event. */

const parentSliderIgnore = [
  ".slider-js.swiperElupsellsidecart",
  ".slider-js.swiperElproductrecommendation",
  ".slider-js.swiperElresurrancecart",
];

const parentSliderIgnoreMobile = [".products-slider", ".other"];

// eslint-disable-next-line max-len
export const blackListSlider = (slider) => parentSliderIgnore.some((exception) => slider.closest(exception))

export const blackListSliderMobile = (slider) => {
  if (window.innerWidth <= 600) {
    return parentSliderIgnoreMobile
      .some((exception) => slider.closest(exception))
  }

  return false;
}
